const ERROR_MESSAGES = {
	ELEMENT_NOT_FOUND: 'CounterAnimation: No counter elements found',
	INIT_FAILED: 'CounterAnimation: Initialization failed'
};

const CONFIG = {
	ANIMATION: {
		DURATION: 2000,
		THRESHOLD: 0.5
	},
	SELECTORS: {
		COUNTERS: '.stats-item h1, .stats-item h2, .stats-item h3, .stats-item h4, .stats-item h5'
	}
};

/**
 * Animate a counter element to its target value
 * @param {HTMLElement} element - The counter element to animate
 * @param {string} target - The target value to count to
 * @returns {void}
 */
const animateCounter = (element, target) => {
	if (!target) return;

	const end = parseInt(target);
	let startTime;

	/**
	 * Animation frame callback
	 * @param {number} currentTime - Current timestamp
	 * @returns {void}
	 */
	const animate = (currentTime) => {
		if (!startTime) startTime = currentTime;
		let progress = (currentTime - startTime) / CONFIG.ANIMATION.DURATION;
		progress = Math.min(progress, 1);

		const currentValue = Math.floor(progress * end);
		const suffix = element.dataset.suffix || '';
		const prefix = element.dataset.prefix || '';

		element.innerText = `${prefix}${currentValue}${suffix}`;

		if (progress < 1) {
			requestAnimationFrame(animate);
		}
	};

	requestAnimationFrame(animate);
};

/**
 * Initialize counter animation
 * @returns {void}
 */
const initializeCounterAnimation = () => {
	const statsItems = document.querySelectorAll(CONFIG.SELECTORS.COUNTERS);

	if (!statsItems.length) {
		console.warn(ERROR_MESSAGES.ELEMENT_NOT_FOUND);
		return;
	}

	try {
		const observer = new IntersectionObserver(
			(entries) => {
				entries.forEach((entry) => {
					if (entry.isIntersecting) {
						const counter = entry.target;
						const target = counter.dataset.target;
						
						if (!target) return;
						
						animateCounter(counter, target);
						observer.unobserve(counter); // Stop observing once animated
					}
				});
			},
			{ threshold: CONFIG.ANIMATION.THRESHOLD }
		);

		statsItems.forEach((counter) => {
			observer.observe(counter);
		});
	} catch (error) {
		console.error(ERROR_MESSAGES.INIT_FAILED, error);
	}
};

export { initializeCounterAnimation };
